export enum NotificationFilterName {
  Elements = 'elements',
  IsNetworkElement = 'isNetworkElement',
  Attribute = 'attribute',
}
